import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentProgress } from './progress/component.progress';
import { ComponentsStars } from './stars/component.stars';
import { ComponentNavStepComponent } from './nav-step/component.nav-step';
import { componentMomentview } from './momentview/component.momentview';
import { componentConfirm } from './confirm/component.confirm';
import { ComponentsAnimation } from './animation/component.animation';
import {componentMomentviewperformance} from './momentviewperformance/component.momentviewperformance';
import {componentAudio} from './audio/component.audio';
import {CasePracticeAnimationModule} from '../app/case-practice-animation/case-practice-animation.module';
import {CasePracticeSimulationHeadComponent} from '../app/case-practice-simulation-head/case-practice-simulation-head.component';
import {CasePracticeAnimationComponent} from '../app/case-practice-animation/case-practice-animation.component';
import {componentMomentviewclash} from './momentviewclash/component.momentviewclash';
import {ComponentQuestionnaire} from './questionnire/component.questionnaire';
import {ComponentQuestionnaireTitle} from './questionnire/child-title/component.questionnaire-title';
import {ComponentQuestionnaireHeadPhoto} from './questionnire/child-photo-head/component.questionnaire-head-photo';
import {ComponentQuestionnaireGrade} from './questionnire/child-grade/component.questionnaire-grade';
import {ComponentQuestionnaireTag} from './questionnire/child-tag/component.questionnaire-tag';
import {ComponentQuestionnaireTextarea} from './questionnire/child-textarea/component.questionnaire-textarea';
import {ComponentBtn} from './button/component.button';
import {ComponentHeader} from './header/component.header';
import {ComponentTip} from './tip/component.tip';
import {ComponentsApproach} from './approach/components.approach';
import {ComponentFilter} from './filter/component.filter';
import {ComponentTextarea} from './textarea/component.textarea';
@NgModule({
  imports: [CommonModule, CasePracticeAnimationModule ],
  declarations: [ComponentProgress,
    ComponentsStars,
    ComponentNavStepComponent,
    componentMomentview,
    componentConfirm,
    ComponentsAnimation,
    componentMomentviewperformance,
    componentMomentviewclash,
    CasePracticeAnimationComponent,
    CasePracticeSimulationHeadComponent,
    componentAudio,
    ComponentQuestionnaire,
    ComponentQuestionnaireTitle,
    ComponentQuestionnaireHeadPhoto,
    ComponentQuestionnaireGrade,
    ComponentQuestionnaireTag,
    ComponentQuestionnaireTextarea,
    ComponentBtn,
    ComponentTip,
    ComponentHeader,
    ComponentsApproach,
    ComponentFilter,
    ComponentTextarea
  ],
  exports: [ ComponentProgress,
    ComponentsStars,
    ComponentNavStepComponent,
    componentMomentview,
    componentConfirm,
    ComponentsAnimation,
    CasePracticeAnimationComponent,
    CasePracticeSimulationHeadComponent,
    componentMomentviewperformance,
    componentMomentviewclash,
    componentAudio,
    ComponentQuestionnaire,
    ComponentQuestionnaireTitle,
    ComponentQuestionnaireHeadPhoto,
    ComponentQuestionnaireGrade,
    ComponentQuestionnaireTag,
    ComponentQuestionnaireTextarea,
    ComponentBtn,
    ComponentTip,
    ComponentHeader,
    ComponentsApproach,
    ComponentFilter,
    ComponentTextarea
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/component/shareModule.ts